import React from "react";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiSelect from "components/VuiSelect";
import { SelectOption } from "../types/SelectTypes";

interface MetricSelectorProps {
  title: string;
  selectedMetric: string;
  metricOptions: SelectOption[];
  onMetricChange: (option: any) => void;
}

const MetricSelector: React.FC<MetricSelectorProps> = ({
  title,
  selectedMetric,
  metricOptions,
  onMetricChange
}) => {
  const selectedOption = metricOptions.find(option => option.value === selectedMetric);

  return (
    <VuiBox display="flex" alignItems="center" justifyContent="space-between">
      <VuiTypography variant="lg" color="white">
        {title}
      </VuiTypography>
      <div style={{ width: '330px' }}>
        <VuiSelect
          //@ts-ignore
          defaultValue={selectedOption}
          onChange={onMetricChange}
          options={metricOptions}
        />
      </div>
    </VuiBox>
  );
};

export default MetricSelector;
